import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreatePhoneLine from "./CreatePhoneLine";
import { usePhoneLinesDataViewLogic } from "./hooks/usePhoneLinesDataViewLogic";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import EditPhoneLine from "./EditPhoneLine";
import DeletePhoneLine from "./DeletePhoneLine";
import BulkDeletePhoneLines from "./BulkDeletePhoneLines";
import ReportDownload from "src/components/Common/UI/ReportDownload/ReportDownload";


const PhoneLineDataView = () => {
  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
    numberOfRowsTitle,
    visibleTotalRecords,
    canDownloadCsv,
    canDownloadExcel,
    downloadAnchorRef
  } = usePhoneLinesDataViewLogic();

  const rightAreaButtons: React.FC = () => {
    return (
      <>
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέα τηλεφωνική γραμμή`)}
      </Button>

      <Button
        type="button"
        color="danger"
        onClick={ () => { actionEvent({action: "bulkdelete"}); }}
        className="mb-1 d-none"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Delete" size="sm" className="icon-light" /> {t(`Μαζική Διαγραφή`)}
      </Button>

      <ReportDownload event={actionEvent} canDownloadCsv={canDownloadCsv} canDownloadExcel={canDownloadExcel} />      
    </>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
      <a ref={downloadAnchorRef} href="#" style={{ display: 'none' }} />
      {loadingDone && (
        <Table
          columns={columns}
          data={data}
          defaultOrderByKeyFilter={"id"}
          showNumberOfRows={true}
          rowSelection={true}
          setRowSelection={setSelectedRowsOfTable}
          multipleRowSelection={false}
          actionRowId={"id"}
          debugMode={false}
          noDataFoundTitle="No phone lines yet"
          isChangeOrderOrVisibilityEnable={false}
          ButtonsAreaLeft={ActionButtons}
          ButtonsAreaRight={rightAreaButtons}
          textPosition="center"
          numberOfRows={visibleTotalRecords}
          numberOfRowsTitle={numberOfRowsTitle}
        />
      )}

      <Modal
        isOpen={!!modalEvent.action}
        closeFilterModal={closeActionModal}
        title={getModalTitleByAction()}  
        size="xl"
        >
          {modalEvent.action === "create" && <CreatePhoneLine handleCloseModal={closeActionModal}/> }
          {modalEvent.action === "edit" && <EditPhoneLine handleCloseModal={closeActionModal} phoneLineId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
          {modalEvent.action === "delete" && <DeletePhoneLine handleCloseModal={closeActionModal} phoneLineId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
          {modalEvent.action === "bulkdelete" && <BulkDeletePhoneLines handleCloseModal={closeActionModal}/> }
      </Modal>

      {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default PhoneLineDataView;

